import './style.scss';
import { Fragment } from 'react';
import { checkStatusLabel, convertLotteryFailureRefundType } from '../../orderStatus/function/createBodyShowList';
import { formatNumber } from 'views/utils/format/FormatNumber';

export type CreateOrderDetailProps = {
  Status: number;
  SymbolName: string;
  TotalApplicationQuantity: number;
  TotalPurchaseQuantity: number;
  LatestApplicationDateTime: string;
  LotteryFailureRefundType: string;
};

export const createOrderDetail = (data: CreateOrderDetailProps) => {
  if (!data) return <div></div>;
  // 抽選後なら
  const isBefourResult = data.Status !== 3;
  const totalPurchaseQuantity = Number(data?.TotalPurchaseQuantity);
  const lotteryFailureRefundType = convertLotteryFailureRefundType(data.LotteryFailureRefundType, true);
  return (
    <div className="detailHeader">
      <div className="detailHeader_label">{checkStatusLabel(data.Status)}</div>
      <span className="detailHeader_body">
        <span className="detailHeader_name">{data.SymbolName}</span>
        {lotteryFailureRefundType && (
          <span className="detailHeader_refundType">
            {`配分出来なかった金額のお取り扱い：${lotteryFailureRefundType}`}
          </span>
        )}
        <span className="detailHeader_applicationInfo">
          <Fragment>
            <span className="detailHeader_applicationLabel">申込日時：</span>
            <span className="detailHeader_applicationValue">{data.LatestApplicationDateTime}</span>
          </Fragment>
          <Fragment>
            <span className="detailHeader_applicationLabel">当選口数：</span>
            <span className="detailHeader_applicationValue">
              {`${isBefourResult && totalPurchaseQuantity === 0 ? '-' : formatNumber(totalPurchaseQuantity)}口`}
            </span>
          </Fragment>
          <Fragment>
            <span className="detailHeader_applicationLabel">申込口数：</span>
            <span className="detailHeader_applicationValue">
              {`${formatNumber(Number(data?.TotalApplicationQuantity))}口`}
            </span>
          </Fragment>
        </span>
      </span>
    </div>
  );
};
